import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button, Form, Card } from "react-bootstrap";
import Layout from "../../layout/Layout";
import Fancybox from "../../Component/FancyBox";
import { API } from "../../App";
import Cookies from "js-cookie";

const KeyboardThemeView = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState([]);
  const [LoadData, setLoadData] = useState([]);
  const navigate = useNavigate();

  const [keyboardTheme, setKeyboardTheme] = useState({
    rank: "",
    name: "",
    thumb_image: "",
    json_name: "",
    loop_Mode: 1,
    keyboardCategory: "",
    status: false,
    is_premium: false,
    is_Border: false,
    is_Watch_Video: false,
    popup: {
      bgType: "",
      bgColor: [],
      bgOrientation: null,
      textColor: "",
      accentKeyBGColor: "",
      accentKeyTextColor: "",
    },
    keys: {
      bgType: "",
      bgColor: [],
      bgOrientation: null,
      borderColor: "",
      borderWidth: 0,
      corners: 0,
      textColor: "",
      opacity: 1,
    },
    fontsPanel: {
      mainBgColor: "",
      separatorColor: "",
      dropDownBgColor: [""],
      dropDownBgOrientation: null,
      switchBgColor: "",
      dropDownImage: "",
      category: {
        textNormalColor: "",
        textSelectedColor: "",
        selectedBgColor: [],
        bgOrientation: null,
        selectedBorderColor: "",
        selectedBorderWidth: 0,
        corners: 0,
      },
      opacity: 1,
    },
    fontsContent: {
      bgType: "",
      separatorColor: "",
      textNormalColor: "",
      textSelectedColor: "",
      bgColorOrientation: null,
      normalBgColor: [],
      selectedBgColor: [],
      selectedBgOrientation: null,
      selectedBorderColor: "",
      selectedBorderWidth: 0,
      normalBorderColor: "",
      normalBorderWidth: 0,
      opacity: 1,
      corners: 0,
      gifCategoryData: {
        searchIconColor: "",
        searchTextColor: "",
        searchBackgroundColor: "",
        searchBorderColor: "",
        searchOpacity: 1,
      },
    },
    otherOptionsPanel: {
      mainBgColor: [],
      optionBgNormalColor: "",
      optionBgSelectedColor: "",
      optionTintNormalColor: "",
      optionTintSelectedColor: "",
      borderBottomColor: "",
    },
    otherKeys: {},
  });

  const loadData = async (_id) => {
    try {
      setLoading(true);
      const token = Cookies.get("jwt");
      const singleThemeResponse = await API.post(
        `/keyboardThemes/${_id}`,
        {},
        { headers: { authorization: `Bearer ${token}` } }
      );
      console.log("🚀 ~ loadData ~ singleThemeResponse:", singleThemeResponse)
      const allThemeResponse = await API.post(
        `/keyboardThemesData/`,
        {},
        { headers: { authorization: `Bearer ${token}` } }
      );

      if (singleThemeResponse.data.response_code === 0) {
        navigate("/");
      } else {
        setKeyboardTheme(singleThemeResponse.data.data || {});
        setLoadData(allThemeResponse.data.data || {});
      }
    } catch (err) {
      console.error("Error loading data:", err);
    } finally {
      setLoading(false);
    }
  };

  const getCategory = (e) => {
    setCategory(e.target.value);
    loadData(e.target.value);
  };

  useEffect(() => {
    loadData(id);
  }, [id]);

  const renderColor = (color) => (
    <div className="color-box-group">
      <Form.Control
        type="color"
        value={color || "#ffffff"}
        className="my-2"
        disabled
      />
      <div
        className="color-box"
        style={{
          backgroundColor: color || "#ffffff",
          width: 30,
          height: 30,
          borderRadius: 6,
          border: "1px solid #ccc",
        }}
      ></div>
    </div>
  );

  const renderColorArray = (arr = []) =>
    (arr || []).map((c, i) => (
      <div key={i} className="my-0">
        {renderColor(c)}
      </div>
    ));

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3>
          <Link to="/keyboard/theme" className="btn btn-primary btn-icon me-3">
            <i className="bx bxs-left-arrow-alt"></i>
          </Link>
          View Keyboard theme - <span>{keyboardTheme?.name || "—"}</span>
        </h3>

        <Row className="align-items-center">
          <Col md="auto" xs={6}>
            <Form.Select
              className="my-1"
              onChange={(e) => {
                getCategory(e);
              }}
            >
              {LoadData.map((dataVal, ind) => (
                <option
                  key={ind}
                  value={dataVal._id}
                  selected={keyboardTheme?.name === dataVal.name}
                >
                  {dataVal.name}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md="auto" xs={6}>
            <Link to={`/keyboard/theme/edit/${id}`}>
              <Button variant="primary">Edit</Button>
            </Link>
          </Col>
        </Row>
      </div>

      <div className="page-content">
        <Card>
          <Card.Body>
            {loading && <div className="loader table-loader"></div>}
            <Fancybox>
              <Row>
                {/* BASIC INFO */}
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Rank</p>
                    <span>{keyboardTheme?.rank ?? "—"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Name</p>
                    <span>{keyboardTheme?.name ?? "—"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Thumb Image</p>
                    {keyboardTheme?.thumb_image ? (
                      <Fancybox>
                        <a
                          data-fancybox="gallery"
                          href={keyboardTheme.thumb_image}
                        >
                          <img
                            src={keyboardTheme.thumb_image}
                            className="hv-30 rounded-3 img-fluid"
                            alt="Thumb"
                          />
                        </a>
                      </Fancybox>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Thumb Image (iPhone)</p>
                    {keyboardTheme?.thumb_image_iphone ? (
                      <Fancybox>
                        <a
                          data-fancybox="gallery"
                          href={keyboardTheme.thumb_image_iphone}
                        >
                          <img
                            src={keyboardTheme.thumb_image_iphone}
                            className="hv-30 rounded-3 img-fluid"
                            alt="Thumb iPhone"
                          />
                        </a>
                      </Fancybox>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Thumb Image (iPad)</p>
                    {keyboardTheme?.thumb_image_ipad ? (
                      <Fancybox>
                        <a
                          data-fancybox="gallery"
                          href={keyboardTheme.thumb_image_ipad}
                        >
                          <img
                            src={keyboardTheme.thumb_image_ipad}
                            className="hv-30 rounded-3 img-fluid"
                            alt="Thumb iPad"
                          />
                        </a>
                      </Fancybox>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Full Image (iPhone)</p>
                    {keyboardTheme?.full_image_iphone ? (
                      <Fancybox>
                        <a
                          data-fancybox="gallery"
                          href={keyboardTheme.full_image_iphone}
                        >
                          <img
                            src={keyboardTheme.full_image_iphone}
                            className="hv-30 rounded-3 img-fluid"
                            alt="Full iPhone"
                          />
                        </a>
                      </Fancybox>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Full Image (iPad)</p>
                    {keyboardTheme?.full_image_ipad ? (
                      <Fancybox>
                        <a
                          data-fancybox="gallery"
                          href={keyboardTheme.full_image_ipad}
                        >
                          <img
                            src={keyboardTheme.full_image_ipad}
                            className="hv-30 rounded-3 img-fluid"
                            alt="Full iPad"
                          />
                        </a>
                      </Fancybox>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Watch Ad Image</p>
                    {keyboardTheme?.keyboard_full_image_watch_ad ? (
                      <Fancybox>
                        <a
                          data-fancybox="gallery"
                          href={keyboardTheme.keyboard_full_image_watch_ad}
                        >
                          <img
                            src={keyboardTheme.keyboard_full_image_watch_ad}
                            className="hv-30 rounded-3 img-fluid"
                            alt="Thumb"
                          />
                        </a>
                      </Fancybox>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">JSON File</p>
                    {keyboardTheme?.json_name ? (
                      <a download href={keyboardTheme.json_name}>
                        <Button className="Zip-downlode-btn btn-icon">
                          <i className="bx bxs-download"></i>
                        </Button>
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>
                {/* FLAGS */}
                <Col md={3}>
                  <div className="mb-4">
                    <p className="fw-bold mb-0">Is Premium</p>
                    <span>{keyboardTheme?.is_premium ? "true" : "false"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="fw-bold mb-0">Status</p>
                    <span>{keyboardTheme?.status ? "true" : "false"}</span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="fw-bold mb-0">Is Watch Video</p>
                    <span>
                      {keyboardTheme?.is_Watch_Video ? "true" : "false"}
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-4">
                    <p className="fw-bold mb-0">Loop Mode</p>
                    <span>
                      {keyboardTheme?.loop_Mode === 1
                        ? "Auto Reverse"
                        : "For Loop"}
                    </span>
                  </div>
                </Col>

                {/* CATEGORY */}
                <Col md={3}>
                  <p className="fw-bold mb-0">Keyboard Category</p>
                  <span>{keyboardTheme?.keyboardCategory?.name}</span>
                </Col>

                <Col md={3}>
                  <div className="mb-4">
                    <p className="mb-0 fw-bold">Keyboard BG Image</p>
                    {keyboardTheme?.keyboard_bg_image ? (
                      <Fancybox>
                        <a
                          data-fancybox="gallery"
                          href={keyboardTheme.keyboard_bg_image}
                        >
                          <img
                            src={keyboardTheme.keyboard_bg_image}
                            className="hv-30 rounded-3 img-fluid"
                            alt="keyboard-bg-image"
                          />
                        </a>
                      </Fancybox>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>

                {/* POPUP SECTION */}
                <Col md={12}>
                  <h5 className="mt-4 fw-bold">Popup</h5>
                  <Row>
                    <Col md={3}>
                      <p className="mb-1">Background Type</p>
                      <span className="text-capitalize">
                        {keyboardTheme?.popup?.bgType ?? "—"}
                      </span>
                    </Col>
                    {keyboardTheme?.popup?.bgType === "image" ? (
                      <>
                        <Col md={3}>
                          <p className="mb-1 mt-1">Background Image</p>
                          <Fancybox>
                            <a
                              data-fancybox="gallery"
                              href={keyboardTheme?.popup?.popupBgImage}
                            >
                              <img
                                src={keyboardTheme?.popup?.popupBgImage}
                                className="hv-30 rounded-3"
                                alt="Popup Background"
                              />
                            </a>
                          </Fancybox>
                        </Col>
                        <Col md={3}>
                          <p className="mb-1 mt-1">Side Background Image</p>
                          <Fancybox>
                            <a
                              data-fancybox="gallery"
                              href={keyboardTheme?.popup?.popupBgSideImage}
                            >
                              <img
                                src={
                                  keyboardTheme?.popup?.popupBgSideImage || "-"
                                }
                                className="hv-30 rounded-3"
                                alt="Popup Background"
                              />
                            </a>
                          </Fancybox>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col md={3}>
                          <p className="mb-1">Background Color</p>
                          <div className="d-flex gap-2">
                            {renderColorArray(
                              keyboardTheme?.popup?.bgColor || []
                            )}
                          </div>
                        </Col>
                        <Col md={3}>
                          <p className="mb-1">Orientation</p>
                          <span>
                            {keyboardTheme?.popup?.bgOrientation ?? "—"}
                          </span>
                        </Col>
                        <Col md={3}>
                          <p className="mb-1">Accent Key Background Color</p>
                          {renderColor(keyboardTheme?.popup?.accentKeyBGColor)}
                        </Col>
                        <Col md={3}>
                          <p className="mb-1">Accent Key Text Color</p>
                          {renderColor(keyboardTheme?.popup?.accentKeyTextColor)}
                        </Col>
                      </>
                    )}

                    {/* <Col md={3}>
                      <p className="mb-1">Background Colors</p>
                      <div className="d-flex gap-2">
                        {renderColorArray(keyboardTheme?.popup?.bgColor || [])}
                      </div>
                    </Col> */}
                    {/* <Col md={3}>
                      <p className="mb-1">Orientation</p>
                      <span>{keyboardTheme?.popup?.bgOrientation ?? "—"}</span>
                    </Col> */}
                    <Col md={3}>
                      <p className="mb-1">Text Color</p>
                      {renderColor(keyboardTheme?.popup?.textColor)}
                    </Col>
                  </Row>
                </Col>

                {/* KEYS SECTION */}
                <Col md={12}>
                  <h5 className="mt-4 fw-bold">Keys</h5>
                  <Row>
                    <Col md={3}>
                      <p className="mb-1">Background Type</p>
                      <span className="text-capitalize">
                        {keyboardTheme?.keys?.bgType ?? "—"}
                      </span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-1">Opacity</p>
                      <span>{keyboardTheme?.keys?.opacity}</span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-1">Text Color</p>
                      {renderColor(keyboardTheme?.keys?.textColor)}
                    </Col>
                    <Col md={3}>
                      <p className="mb-1">Border Color</p>
                      {renderColor(keyboardTheme?.keys?.borderColor)}
                    </Col>
                    <Col md={3}>
                      <p className="mb-1">Border Width</p>
                      <span>{keyboardTheme?.keys?.borderWidth ?? 0} px</span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-1 mt-2">Corners Radius</p>
                      <span>{keyboardTheme?.keys?.corners ?? 0} px</span>
                    </Col>

                    {keyboardTheme?.keys?.bgType === "image" ? (
                      <>
                        <Col md={3}>
                          <p className="mb-1 mt-1">Background Image</p>
                          <Fancybox>
                            <a
                              data-fancybox="gallery"
                              href={keyboardTheme?.keys?.bgImage}
                            >
                              <img
                                src={keyboardTheme?.keys?.bgImage}
                                className="hv-30 rounded-3"
                                alt="Keys Background"
                              />
                            </a>
                          </Fancybox>
                        </Col>
                        <Col md={3}>
                          <p className="mb-1 mt-1">IPad Background Image</p>
                          <Fancybox>
                            <a
                              data-fancybox="gallery"
                              href={keyboardTheme?.keys?.keysIpadBgImage}
                            >
                              <img
                                src={keyboardTheme?.keys?.keysIpadBgImage}
                                className="hv-30 rounded-3"
                                alt="Keys Background"
                              />
                            </a>
                          </Fancybox>
                        </Col>
                        <Col md={3}>
                          <p className="mb-1 mt-1">Background Image (Landscape)</p>
                          <Fancybox>
                            <a
                              data-fancybox="gallery"
                              href={keyboardTheme?.keys?.keysBgImageLandscape}
                            >
                              <img
                                src={keyboardTheme?.keys?.keysBgImageLandscape}
                                className="hv-30 rounded-3"
                                alt="Keys Background"
                              />
                            </a>
                          </Fancybox>
                        </Col>
                        <Col md={3}>
                          <p className="mb-1 mt-1">IPad Background Image (Landscape)</p>
                          <Fancybox>
                            <a
                              data-fancybox="gallery"
                              href={keyboardTheme?.keys?.keysIpadBgImageLandscape}
                            >
                              <img
                                src={keyboardTheme?.keys?.keysIpadBgImageLandscape}
                                className="hv-30 rounded-3"
                                alt="Keys Background"
                              />
                            </a>
                          </Fancybox>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col md={3}>
                          <p className="mb-1 mt-1">Background Color</p>
                          <div className="d-flex gap-2">
                            {renderColorArray(
                              keyboardTheme?.keys?.bgColor || []
                            )}
                          </div>
                        </Col>
                        <Col md={3}>
                          <p className="mb-1">Orientation</p>
                          <span>
                            {keyboardTheme?.keys?.bgOrientation ?? "—"}
                          </span>
                        </Col>
                      </>
                    )}
                  </Row>
                </Col>

                {/* FONT PANEL */}
                <Col md={12}>
                  <h5 className="mt-4 fw-bold">Fonts Panel</h5>
                  <Row>
                    <Col md={3}>
                      <p className="mb-0">Main Background Color</p>
                      {renderColor(keyboardTheme?.fontsPanel?.mainBgColor)}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Separator Color</p>
                      {renderColor(keyboardTheme?.fontsPanel?.separatorColor)}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Dropdown Background Color</p>
                      <div className="d-flex gap-2">
                        {renderColorArray(
                          keyboardTheme?.fontsPanel?.dropDownBgColor
                        )}
                      </div>
                    </Col>
                    <Col md={3}>
                      <p className="mb-2">Dropdown Orientation</p>
                      <span>
                        {keyboardTheme?.fontsPanel?.dropDownBgOrientation ||
                          "-"}
                      </span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-2">DropDown Image</p>
                      {keyboardTheme?.fontsPanel?.dropDownImage ? (
                        <Fancybox>
                          <a
                            data-fancybox="gallery"
                            href={keyboardTheme?.fontsPanel?.dropDownImage}
                          >
                            <img
                              src={keyboardTheme?.fontsPanel?.dropDownImage}
                              className="hv-30 rounded-3"
                              alt="Dropdown"
                            />
                          </a>
                        </Fancybox>
                      ) : (
                        "-"
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Switch Background Color</p>
                      {renderColor(keyboardTheme?.fontsPanel?.switchBgColor)}
                    </Col>
                    <Col md={3}>
                      <p className="mb-1">Opacity</p>
                      <span>{keyboardTheme?.fontsPanel?.opacity}</span>
                    </Col>

                    {/* CATEGORY INSIDE FONTS PANEL */}
                    <Col md={12}>
                      <h6 className="fw-bold mt-3">Category</h6>
                      <Row>
                        <Col md={3}>
                          <p className="mb-0">Text Normal Color</p>
                          {renderColor(
                            keyboardTheme?.fontsPanel?.category?.textNormalColor
                          )}
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">Text Selected Color</p>
                          {renderColor(
                            keyboardTheme?.fontsPanel?.category
                              ?.textSelectedColor
                          )}
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">Selected Background Color</p>
                          <div className="d-flex gap-2 mt-0">
                            {renderColorArray(
                              keyboardTheme?.fontsPanel?.category
                                ?.selectedBgColor
                            )}
                          </div>
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">
                            Selected Background Orientation
                          </p>
                          <span>
                            {keyboardTheme?.fontsPanel?.category
                              ?.bgOrientation || "-"}
                          </span>
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">Selected Border Width</p>
                          <span>
                            {keyboardTheme?.fontsPanel?.category
                              ?.selectedBorderWidth || 0}{" "}
                            px
                          </span>
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">Selected Border Color</p>
                          {renderColor(
                            keyboardTheme?.fontsPanel?.category
                              ?.selectedBorderColor
                          )}
                        </Col>
                        <Col md={3}>
                          <p className="mb-1">Corner Radius</p>
                          <span>
                            {keyboardTheme?.fontsPanel?.category?.corners ?? 0}{" "}
                            px
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                {/* FONT CONTENT SECTION */}
                <Col md={12}>
                  <h5 className="mt-4 fw-bold">Fonts Content</h5>
                  <Row>
                    <Col md={3}>
                      <p className="mb-0">Separator Color</p>
                      {renderColor(keyboardTheme?.fontsContent?.separatorColor)}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Normal Text Color</p>
                      {renderColor(
                        keyboardTheme?.fontsContent?.textNormalColor
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Selected Text Color</p>
                      {renderColor(
                        keyboardTheme?.fontsContent?.textSelectedColor
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Normal Background Color</p>
                      <div className="d-flex gap-2">
                        {renderColorArray(
                          keyboardTheme?.fontsContent?.normalBgColor
                        )}
                      </div>
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Background Orientation</p>
                      <span>
                        {keyboardTheme?.fontsContent?.bgColorOrientation || "-"}
                      </span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Selected Background Color</p>
                      <div className="d-flex gap-2">
                        {renderColorArray(
                          keyboardTheme?.fontsContent?.selectedBgColor
                        )}
                      </div>
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Selected Background Orientation</p>
                      <span>
                        {keyboardTheme?.fontsContent?.selectedBgOrientation ||
                          "-"}
                      </span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Selected Border Color</p>
                      {renderColor(
                        keyboardTheme?.fontsContent?.selectedBorderColor
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Selected Border Width</p>
                      <span>
                        {keyboardTheme?.fontsContent?.selectedBorderWidth} px
                      </span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Normal Border Color</p>
                      {renderColor(
                        keyboardTheme?.fontsContent?.normalBorderColor
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Normal Border Width</p>
                      <span>
                        {keyboardTheme?.fontsContent?.normalBorderWidth} px
                      </span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Opacity</p>
                      <span>{keyboardTheme?.fontsContent?.opacity}</span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Selection Icon Image</p>
                      {keyboardTheme?.fontsContent
                        ?.fontsContentSelectionIconImage ? (
                        <Fancybox>
                          <a
                            data-fancybox="gallery"
                            href={
                              keyboardTheme?.fontsContent
                                ?.fontsContentSelectionIconImage
                            }
                          >
                            <img
                              src={
                                keyboardTheme?.fontsContent
                                  ?.fontsContentSelectionIconImage
                              }
                              className="hv-30 rounded-3"
                              alt="Dropdown"
                            />
                          </a>
                        </Fancybox>
                      ) : (
                        "-"
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-1">Corner Radius</p>
                      <span>
                        {keyboardTheme?.fontsContent?.corners ?? 0} px
                      </span>
                    </Col>
                    <Col md={12}>
                      <h6 className="fw-bold mt-4">GIF Category</h6>
                      <Row>
                        <Col md={3}>
                          <p className="mb-0">GIF Back Icon Image</p>
                          {keyboardTheme?.fontsContent?.gifCategoryData
                            ?.gifBackImage ? (
                            <Fancybox>
                              <a
                                data-fancybox="gallery"
                                href={
                                  keyboardTheme?.fontsContent?.gifCategoryData
                                    ?.gifBackImage
                                }
                              >
                                <img
                                  src={
                                    keyboardTheme?.fontsContent?.gifCategoryData
                                      ?.gifBackImage
                                  }
                                  className="hv-30 rounded-3"
                                  alt="Dropdown"
                                />
                              </a>
                            </Fancybox>
                          ) : (
                            "-"
                          )}
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">Search Icon Color</p>
                          {renderColor(
                            keyboardTheme?.fontsContent?.gifCategoryData
                              ?.searchIconColor
                          )}
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">Search Text Color</p>
                          {renderColor(
                            keyboardTheme?.fontsContent?.gifCategoryData
                              ?.searchTextColor
                          )}
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">Search Background Color</p>
                          {renderColor(
                            keyboardTheme?.fontsContent?.gifCategoryData
                              ?.searchBackgroundColor
                          )}
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">Search Border Color</p>
                          {renderColor(
                            keyboardTheme?.fontsContent?.gifCategoryData
                              ?.searchBorderColor
                          )}
                        </Col>
                        <Col md={3}>
                          <p className="mb-0">Opacity</p>
                          <span>
                            {
                              keyboardTheme?.fontsContent?.gifCategoryData
                                ?.searchOpacity
                            }
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                {/* OTHER OPTIONS PANEL */}
                <Col md={12}>
                  <h5 className="mt-4 fw-bold">Other Options Panel</h5>
                  <Row>
                    <Col md={3}>
                      <p className="mb-0">Main Background Colors</p>
                      <div className="d-flex gap-2">
                        {renderColorArray(
                          keyboardTheme?.otherOptionsPanel?.mainBgColor || []
                        )}
                      </div>
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Orientation</p>
                      <span>
                        {keyboardTheme?.otherOptionsPanel?.mainBgOrientation ??
                          "-"}
                      </span>
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Option Background Normal Color</p>
                      {renderColor(
                        keyboardTheme?.otherOptionsPanel?.optionBgNormalColor
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Option Background Selected Color</p>
                      {renderColor(
                        keyboardTheme?.otherOptionsPanel?.optionBgSelectedColor
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Option Tint Normal Color</p>
                      {renderColor(
                        keyboardTheme?.otherOptionsPanel?.optionTintNormalColor
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Option Tint Selected Color</p>
                      {renderColor(
                        keyboardTheme?.otherOptionsPanel
                          ?.optionTintSelectedColor
                      )}
                    </Col>
                    <Col md={3}>
                      <p className="mb-0">Border Bottom Color</p>
                      {renderColor(
                        keyboardTheme?.otherOptionsPanel?.borderBottomColor
                      )}
                    </Col>
                  </Row>
                </Col>

                {/* OTHER KEYS */}
                <Col md={12}>
                  <h5 className="mt-4 fw-bold">Other Keys</h5>
                  {Object.entries(keyboardTheme?.otherKeys || {}).map(
                    ([key, value], idx) => (
                      <Card key={idx} className="my-2">
                        <Card.Body>
                          <h6 className="fw-bold text-capitalize">{key}</h6>
                          <Row>
                            <Col md={3}>
                              <p className="mb-0">Background Type</p>
                              <span>{value?.bgType ?? "—"}</span>
                            </Col>
                            <Col md={3}>
                              <p className="mb-0">Text Color</p>
                              {renderColor(value?.textColor)}
                            </Col>
                            <Col md={3}>
                              <p className="mb-0">Border Color</p>
                              {renderColor(value?.borderColor)}
                            </Col>
                            {value?.bgType === "color" && (
                              <Col md={3}>
                                <p className="mb-0">Background Colors</p>
                                <div className="d-flex gap-2">
                                  {renderColorArray(value?.bgColor || [])}
                                </div>
                              </Col>
                            )}
                            <Col md={3}>
                              <p className="mb-1">Orientation</p>
                              <span>{value?.bgOrientation ?? "—"}</span>
                            </Col>
                            <Col md={3}>
                              <p className="mb-1">Opacity</p>
                              <span>{value?.opacity ?? "—"}</span>
                            </Col>
                            <Col md={3}>
                              <p className="mb-1">Corner Radius</p>
                              <span>{value?.corners ?? "—"} px</span>
                            </Col>
                            {value?.bgType === "image" && (
                              <>
                                <Col md={3}>
                                  <p className="mb-1">Image</p>
                                  <span>
                                    <Fancybox>
                                      <a
                                        data-fancybox={`other-keys-${key}`}
                                        href={value?.bgImage}
                                      >
                                        <img
                                          src={value?.bgImage}
                                          className="hv-30 rounded-3"
                                          alt="Thumb Images"
                                        />
                                      </a>
                                    </Fancybox>
                                  </span>
                                </Col>
                                <Col md={3}>
                                  <p className="mb-1">IPad Image</p>
                                  <span>
                                    <Fancybox>
                                      <a
                                        data-fancybox={`other-keys-${key}`}
                                        href={value?.ipadBgImage}
                                      >
                                        <img
                                          src={value?.ipadBgImage}
                                          className="hv-30 rounded-3"
                                          alt="Thumb Images"
                                        />
                                      </a>
                                    </Fancybox>
                                  </span>
                                </Col>
                                <Col md={3}>
                                  <p className="mb-1">Landscape Image</p>
                                  <span>
                                    <Fancybox>
                                      <a
                                        data-fancybox={`other-keys-${key}`}
                                        href={value?.bgImageLandscape}
                                      >
                                        <img
                                          src={value?.bgImageLandscape}
                                          className="hv-30 rounded-3"
                                          alt="Thumb Images"
                                        />
                                      </a>
                                    </Fancybox>
                                  </span>
                                </Col>
                                <Col md={3}>
                                  <p className="mb-1">IPad Landscape Image</p>
                                  <span>
                                    <Fancybox>
                                      <a
                                        data-fancybox={`other-keys-${key}`}
                                        href={value?.ipadBgImageLandscape}
                                      >
                                        <img
                                          src={value?.ipadBgImageLandscape}
                                          className="hv-30 rounded-3"
                                          alt="Thumb Images"
                                        />
                                      </a>
                                    </Fancybox>
                                  </span>
                                </Col>
                              </>
                            )}
                          </Row>
                        </Card.Body>
                      </Card>
                    )
                  )}
                </Col>
              </Row>
            </Fancybox>
          </Card.Body>
        </Card>
      </div>
    </Layout>
  );
};

export default KeyboardThemeView;
